import { reactive } from 'vue';

// Buffers the latest unseen successful Fangate sale per inbox. The ActionCable
// connector writes here for EVERY incoming `fangate.sale` event (even when no
// chat window is mounted), so the dismissible in-chat sale pop-up can still show
// on the FIRST chat of that inbox the agent opens next. A mounted chat window
// also listens live via the `fangate:sale` emitter event for the immediate case.
//
// Keyed by inbox id; only the most recent sale per inbox is kept (a pop-up is a
// single transient nudge — the full list lives in the Fangate panel + the
// per-conversation activity entries).
export const pendingByInbox = reactive({});

export function rememberSale(payload) {
  const inboxId = payload && payload.inbox_id;
  if (inboxId == null) return;
  pendingByInbox[inboxId] = payload;
}

// Returns + clears the buffered sale for an inbox (if any).
export function takeSale(inboxId) {
  if (inboxId == null) return null;
  const sale = pendingByInbox[inboxId];
  if (sale) delete pendingByInbox[inboxId];
  return sale || null;
}
